import React from "react";

interface CardProps {
  header?: React.ReactNode | undefined;
  children?: React.ReactNode | undefined;
  footer?: React.ReactNode | undefined;
  padding?: string | number;
  gap?: string | number;
}

const Card: React.FC<CardProps> = ({ header, children, footer, padding, gap }) => {
  return (
    <div
      className="rounded-2xl overflow-hidden bg-card text-card-foreground shadow flex flex-col"
      style={{
        padding: padding ?? "1rem",
        gap: gap ?? "1rem",
      }}
    >
      {header && <header>{header}</header>}
      {children && <section>{children}</section>}
      {footer && <footer>{footer}</footer>}
    </div>
  );
};

export default Card;
